import React from "react";
import "./Contact.css";

const ContactPage = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="hero">
        <h1>Contact Us</h1>
      </section>

      {/* Contact Cards */}
      <section className="contact-cards">
        <div className="card2">
          <h2 style={{ fontFamily: 'Montserrat, sans-serif' }}>Reach Us At</h2>
          <hr />
          <ul>
            <li style={{ fontFamily: 'Montserrat, sans-serif' }}><i className="fa-solid fa-phone-volume"></i>&nbsp; +91-98251-10526</li>
            <li style={{ fontFamily: 'Montserrat, sans-serif' }}><i className="fas fa-envelope"></i>&nbsp; divyamads2014@gmail.com</li>
            <li style={{fontFamily:'Montserrat, sans-serif',textAlign:"left"}}><i className="fa-solid fa-location-dot"></i>&nbsp;410, 4th Floor, Proton Plus, Above Croma Showroom, B/h. Star Bazaar, Pal, Adajan, Surat 395009, Gujarat, INDIA.</li>
          </ul>
        </div>

        <div className="card2">
          <h2 style={{ fontFamily: 'Montserrat, sans-serif' }}
>Branding & Collaboration</h2>
          <hr />
          <ul>
            <li style={{ fontFamily: 'Montserrat, sans-serif' }}
><i className="fas fa-envelope"></i>&nbsp; divyamads2014@gmail.com</li>
            <li style={{fontFamily:'Montserrat, sans-serif',textAlign:"left"}}><i className="fa-solid fa-location-dot"></i>&nbsp; 410, 4th Floor, Proton Plus, Above Croma Showroom, B/h. Star Bazaar, Pal, Adajan, Surat 395009, Gujarat, INDIA.</li>
          </ul>
        </div>
      </section>

      {/* Form and Map Section */}
      <section className="form-map-container">
        <form className="feedback-form">
          <h3 style={{ fontFamily: 'Montserrat, sans-serif' }}
>Contact Me</h3>
          <hr />
          <label style={{ fontFamily: 'Montserrat, sans-serif' }}
 htmlFor="email">Email Address*</label>
          <input style={{ fontFamily: 'Montserrat, sans-serif' }}
 type="email" id="email" name="email" placeholder="abc@geeksforgeeks.org" required />

          <label style={{ fontFamily: 'Montserrat, sans-serif' }}
 htmlFor="contact">Contact No.</label>
          <input style={{ fontFamily: 'Montserrat, sans-serif' }}
 type="tel" id="contact" name="contact" placeholder="+91-" />

          <label style={{ fontFamily: 'Montserrat, sans-serif' }}
 htmlFor="message">Message*</label>
          <textarea style={{ fontFamily: 'Montserrat, sans-serif' }}
 id="message" name="message" rows="4" placeholder="Write your message here..." required></textarea>

          <button type="submit">Submit</button>
        </form>

        <div className="map-container">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14693.282216437936!2d72.7688526!3d21.2047285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x123456789abcdef!2sDivyam%20Ads!5e0!3m2!1sen!2sin!4v1700000000000"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
